<template>
  <div class="payout-detail-modal">
    <el-dialog :title="$t('data.payout_details')" class="diglog-card" :visible.sync="dialogTableVisible" width="580px" @open="getDetailInfo">
      <div class="header-line" />
      <template v-if="merchantInfo.transaction_type === TRANSACTION_TYPE_FX" >
        <div class="total">
          <div class="total-item">
            <div class="total-title">{{ $t('data.destination_amount') }}:</div>
            <div class="total-num"> {{ merchantInfo.destination_currency }}  {{ merchantInfo.destination_amount | toDivideWithDot }}</div>
          </div>
          <div class="line" />
          <div class="total-item">
            <div class="total-title">{{ $t('data.fee') }}:</div>
            <div class="total-num">{{ merchantInfo.mch_foreign_exchange_fee_resp.fee_split_currency }}  {{ merchantInfo.mch_foreign_exchange_fee_resp.fee_split | toDivideWithDot }}</div>
          </div>
        </div>
        <div class="total">
          <div class="total-item">
            <div class="total-title">{{ $t('data.source_amount') }}:</div>
            <div class="total-num">{{  merchantInfo.source_currency}}  {{ merchantInfo.source_amount | toDivideWithDot }}</div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="total">
        <div class="total-item">
          <div class="total-title">{{ $t('data.destination_amount') }}:</div>
          <div class="total-num"> {{ $store.getters.currency }}  {{ merchantInfo.po_trans_amount | toDivideWithDot }}</div>
        </div>
        <div class="line" />
        <div class="total-item">
          <div class="total-title">{{ $t('data.fee') }}:</div>
          <div class="total-num">{{ $store.getters.currency }} {{ merchantInfo.fee_split | toDivideWithDot }}</div>
        </div>
      </div>
      </template>

      <div class="section-title">
        {{ $t('data.timeline') }}
      </div>
      <div class="line-bottom-1px" />

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.payout_created') }}</span>
        <span class="content-blue">{{ $t('data.payout_completed') }}</span>
      </div>

      <div class="item">
        <span class="item-left" style="color: #4B5567">{{ merchantInfo.transaction_create_time }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_return_time }}</span>
      </div>

      <div class="section-title">
        {{ $t('data.description') }}
      </div>
      <div class="line-bottom-1px" />
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.transaction_id') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_id }}</span>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.merchant_order_id') }}</span>
        <span class="content-gray">{{ merchantInfo.merchant_order_id }}</span>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.remitting_bank') }}</span>
        <span class="content-gray">{{ merchantInfo.sender_bank_name }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.remittance_account') }}</span>
        <span class="content-gray">{{ merchantInfo.sender_bank_account |strAesDecryptAndAsterisk }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_name') }}</span>
        <span class="content-gray">{{ merchantInfo.recipient_name |strAesDecryptAndAsterisk }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_channel') }}</span>
        <span class="content-gray">{{ merchantInfo.recipient_channel }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_account') }}</span>
        <span class="content-gray">{{ merchantInfo.recipient_account | strAesDecryptAndAsterisk }}</span>
      </div>

      <template v-if="merchantInfo.transaction_type === TRANSACTION_TYPE_FX" >
          <div class="item">
          <span class="item-left content-blue">{{ $t('data.quote_id') }}</span>
          <span class="content-gray">{{ merchantInfo.quote_id }}</span>
        </div>

        <div class="item">
          <span class="item-left content-blue">{{ $t('data.exchange_rate') }}</span>
          <span class="content-gray">{{ merchantInfo.exchange_rate }}</span>
        </div>

        <div class="item">
          <span class="item-left content-blue">{{ $t('data.exchange_transaction_id') }}</span>
          <span class="content-gray">{{ merchantInfo.exchange_no }}</span>
        </div>
      </template>

      <el-tag :type="getPOTransactionStatusType(merchantInfo.po_trans_status)" min-width="150" class="tag-custom payout-status"> {{ getPOTransactionStatusLabel(merchantInfo.po_trans_status,merchantInfo.refund_type) }}</el-tag>
      <div class="btn-container">
        <el-button v-if="[3,4].indexOf(merchantInfo.po_trans_status) !== -1" class="btn-retry btn" :disabled="merchantInfo.refund_type === 2" type="primary" plain size="small" @click="retryNotice">
          {{ $t('data.resend_notice') }}
        </el-button>
        <el-button class="btn-download" type="info" size="small" @click="onClickDownload">
          {{ $t('components.download') }}
        </el-button>
      </div>
      <DetailDownload ref="detailDownload" :merchant-info="merchantInfo" />
    </el-dialog>
  </div>
</template>

<script>
import { fetchPayoutDetail, disburseNotice } from '@/api/customer-service/customer-service'
import { poTransStatusWithRefundMap } from '@/utils/maps'
import DetailDownload from '../PayoutDetailDownload.vue'
export default {
  name: 'Po_Details_Modal',
  components: {
    DetailDownload
  },
  props: {
    detailId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    this.TRANSACTION_TYPE_FX = 4
    return {
      dialogTableVisible: false, // 控制弹框显示隐藏
      listLoading: false,
      merchantInfo: { merchant: { merchant_basic_info: {}}, disbursement_fee: {}} // 用户基本信息
    }
  },
  computed: {
    getPOTransactionStatusType() {
      return function(value) {
        return poTransStatusWithRefundMap(value).type
      }
    },
    getPOTransactionStatusLabel() {
      return function(value, refund_type) {
        if (refund_type === 2) {
          value = 99
        }
        return poTransStatusWithRefundMap(value).label
      }
    }
  },
  mounted() {
  },
  methods: {
    getDetailInfo() {
      fetchPayoutDetail({ transaction_id: this.detailId }).then(res => {
        this.merchantInfo = res.data
      })
    },
    // 改变弹框状态
    changModalStatus(value) {
      this.dialogTableVisible = value
    },
    onClickDownload() {
      this.$refs.detailDownload.saveImg()
    },
    retryNotice() {
      this.$confirm('Did you want to re-try notice?', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        const params = {
          transaction_id: this.detailId
        }
        disburseNotice(params).then(res => {
          this.$message.success('Success')
        })
      })
    }
  }
}
</script>

<style>
.payout-detail-modal .el-dialog__title {
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 16px;
  color: #000000;
}
.payout-detail-modal .header-line{
  margin: -26px 0 0;
  border-bottom: 1px solid #D3D7DF;
}
</style>
<style scoped lang="scss">
.btn-container{
  margin-top: 32px;
  display: flex;
  .btn-download,.btn-retry{
    flex: 1;
  }
  .btn-retry{
    margin-left: 24px;
  }
}
.total{
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 18px;
  min-width: 300px;

  .total-item{
    flex: 1;
    min-width: 0;
  }
  .line{
    display: inline-block;
    content:'';
    height: 52px;
    width: 1px;
    margin: 0 16px;
    background: #D3D7DF;
  }
  &-title{
    font-size: 14px;
    line-height: 17px;
    color: #606266;
  }
  &-num{
    margin-top: 12px;
    font-size: 22px;
    font-family: Source Han Sans SC;
    font-weight: 600;  font-family: 'Inter-SemiBold';
    line-height: 1.2;
    color: #3855F1;
    word-break: break-all;
  }
}
.item{
  display: flex;
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.content-blue{
  flex: 1;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 17px;
  color: #1D3A71;
}
.content-gray{
  flex: 1;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 15px;
  color: #4B5567;
}

.payout-detail-modal{
  .payout-status{
    text-align: center;
    position: absolute;
    top: 20px;
    left: 230px;
  }
}
</style>
